// Aroha Homes brand assets
export const LOGO_LIGHT_BG =
  "https://customer-assets.emergentagent.com/job_aroha-rooms/artifacts/nimxbgyu_Aroha%20homes%20-%20Main%20logo-01.png";
// version with dark/black background
export const LOGO_DARK_BG =
  "https://customer-assets.emergentagent.com/job_aroha-rooms/artifacts/24l59e1m_Aroha%20homes%20-%20Main%20logo-02.png";

export function Logo({ variant = "light", className = "", testId = "aroha-logo" }) {
  // variant 'light' = used on LIGHT surfaces (uses the white-bg PNG, mix-blend isolates the wordmark)
  // variant 'dark'  = used on DARK surfaces (uses the dark-bg PNG)
  const src = variant === "dark" ? LOGO_DARK_BG : LOGO_LIGHT_BG;
  // mix-blend-multiply removes the white BG on light surfaces; mix-blend-screen removes black BG on dark surfaces.
  const blend = variant === "dark" ? "mix-blend-screen" : "mix-blend-multiply";
  return (
    <img
      src={src}
      alt="Aroha Homes"
      data-testid={testId}
      className={`${blend} select-none ${className}`}
      draggable={false}
    />
  );
}
